import {
  LIST_ASSESSMENT_TYPE_REQUEST,
  LIST_ASSESSMENT_TYPE_SUCCESS,
  LIST_ASSESSMENT_TYPE_ERROR,
} from '../actions';

export const listAssessmentTypeRequest = () => ({
  type: LIST_ASSESSMENT_TYPE_REQUEST,
});

export const listAssessmentTypeSuccess = (assessmentTypes) => ({
  type: LIST_ASSESSMENT_TYPE_SUCCESS,
  payload: assessmentTypes,
});

export const listAssessmentTypeError = (message) => ({
  type: LIST_ASSESSMENT_TYPE_ERROR,
  payload: { message },
});
